import React from 'react';
import { FiAward, FiCode, FiTarget } from "react-icons/fi";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiTarget />,
        title: 'Atenção aos Detalhes',
        description: 'Em nosso compromisso com a excelência, celebramos a beleza nos detalhes, elevando cada projeto a uma expressão única de qualidade e precisão.'
    },
    {
        icon: <FiAward />,
        title: 'Design Premiado',
        description: 'Explore o extraordinário com nosso Design Premiado. Cada projeto é uma obra-prima, meticulosamente concebida para cativar, comunicar e inspirar.'
    },
    {
        icon: <FiCode />,
        title: 'Desenvolvimento Web',
        description: 'De interfaces intuitivas a recursos inovadores, cada sistema é uma jornada personalizada. Descubra como podemos dar vida à sua visão digital.'
    },
]

const ServiceOne = ({ textAlign, serviceStyle }) => {
    return (
        <div className="row row--15 service-wrapper">
            {ServiceList.map((val, i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{ __html: val.title }}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{ __html: val.description }}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;